import { render, staticRenderFns } from "./BusinessContractor.vue?vue&type=template&id=4423b011&scoped=true&"
import script from "./BusinessContractor.vue?vue&type=script&lang=ts&"
export * from "./BusinessContractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4423b011",
  null
  
)

export default component.exports